export default __webpack_public_path__ + "static/media/I-2024.85e4d27c.pdf";